import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, Divider, Grid, IconButton, InputAdornment, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import view from '../../../ReceivedApp/viewicon.png';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axios from 'axios';
import useModal from '../../../../hooks/useModal';
import { useMessage } from '../../../../components/Header';
import LeaveModel from './LeaveModel';
import { useTheme } from '../../../../style/theme';
import { GoKebabHorizontal } from 'react-icons/go';
import { VscEye } from 'react-icons/vsc';
import { IoIosSearch } from 'react-icons/io';


const LeaveSettingPage = () => {

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { showSuccess } = useMessage();
    const { mode } = useTheme()
    const { modalState: deleteState, openModal: openDelete, closeModal: closeDelete } = useModal()

    let currentOrg = JSON.parse(localStorage.getItem("org"));
    const [leavesTypes, setLeaveType] = useState(null);
    const [selectLeaveType, setSelectLeaveType] = useState({});
    const [openMenuId, setOpenMenuId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredRows = leavesTypes?.filter((row) =>
        row?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
    );

    const toggleMenu = (id) => {
        setOpenMenuId(openMenuId == id ? null : id);
    };

    const fetchLeaveType = useCallback(
        async function () {
            try {
                const response = await axios.get(`/hr/attendance/leaves-types?orgId=${currentOrg?._id}`);
                setLeaveType(response.data.leaveTypes);
            } catch (e) {
                console.log(e);
            }
        },
        [setLeaveType]
    );

    useEffect(() => {
        fetchLeaveType();
    }, [fetchLeaveType]);

    async function deleteLeaveTypes(id) {
        try {
            const res = await axios.delete(`/hr/attendance/leaves-types/${id}`);

            if (res.data.success) {
                showSuccess
                    ('Leave type deleted');
            }
        } catch (e) {
            console.log(e)
        } finally {
            closeDelete();
            fetchLeaveType();
        }
    }

    return (
        <Box sx={{ border: "1px solid #1F1F1F" }} className='md:p-4 rounded-lg'>
            {leavesTypes?.length > 0 ? (
                <>
                    <div className='flex flex-col md:mb-1'>
                        <div className="flex items-center justify-end md:w-full p-4">
                            {/* <div className="p-2">
                        <h1 className="text-xs md:text-2xl text-neutral-500">Leave Settings</h1>
                    </div> */}
                            <div className="flex flex-row items-center justify-center gap-4">
                                {/* <button className='flex  items-center text-white font-bold text-[8px] md:text-[12px] py-1 md:py-1 px-2 md:px-3 rounded bg-sky-500 hover:bg-sky-700'
                            onClick={handleOpen}
                        >
                            Add Leave Type
                        </button> */}
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    sx={{ margin: 0, width: { xs: '100px', md: "250px" } }}
                                    className="flex items-center "

                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment sx={{ marginRight: 0 }} position="start">
                                                <IoIosSearch className="text-gray-400" />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            backgroundColor: "background.main",
                                            borderRadius: "8px",
                                            "& input::placeholder": {
                                                fontSize: "12px",
                                                color: "gray",
                                            },
                                        },
                                    }}
                                />
                                {currentOrg.type == "Owner" &&
                                    <button onClick={() => {
                                        setSelectLeaveType({});
                                        handleOpen();
                                    }} className='flex items-center text-white font-500 text-xs md:text-[14px] py-1 px-3 md:py-3 md:px-4 rounded-lg  bg-[#0080ff] hover:bg-sky-700 '>
                                        Add Leave Type
                                    </button>
                                }
                                {/* <InfoOutlinedIcon /> */}
                            </div>
                        </div>
                    </div>
                    <Box >
                        {/* <p className=" mb-4 border-l-4 border-blue-500 pl-4 text-xl" gutterBottom>
                    Leaves Types
                </p> */}
                        {/* <Box
                    className='w-[97%] ml-2 md:ml-4 border border-zinc-500 rounded-sm mt-10'
                    sx={{
                        overflowY: 'scroll',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none'
                    }}
                >
                    <Grid
                        className='flex flex-row border-b border-zinc-500'

                    >
                        <div className='w-1/3 md:w-[33%] p-4 flex items-center border-r border-zinc-500 text-left text-sm md:text-[16px] font-bold'>
                            Leaves Type
                        </div>
                        <div className='w-1/3 md:w-[33%] p-4 flex items-center border-r border-zinc-500 text-sm md:text-[16px] font-bold'>
                            Number of Leaves
                        </div>
                        <div className='w-1/3 md:w-[33%] flex items-center p-4  text-sm md:text-[16px] font-bold'>
                            Actions
                        </div>

                    </Grid>
                    {leavesTypes?.map((item, index) => (
                        <Grid
                            key={index}
                            className='flex flex-row border-b border-zinc-500'

                        >
                            <div className='w-1/3 md:w-[33%] p-4 flex items-center border-r border-zinc-500 text-left text-sm md:text-[12px]'>
                                {item.name}
                            </div>
                            <div className='w-1/3 md:w-[33%] p-4 flex items-center border-r border-zinc-500 text-sm md:text-[12px]'>
                                {item.noOfLeaves}
                            </div>
                            <div className='w-1/3 md:w-[33%] flex items-center flex flex-row gap-3 p-4  text-sm md:text-[12px]'>
                                <IconButton onClick={() => {
                                    setSelectLeaveType(item);
                                    handleOpen();
                                }}><img src={view} alt="view" className="w-4 h-4" /></IconButton>
                                <IconButton onClick={() => {
                                    setSelectLeaveType(item);
                                    openDelete();
                                }}><DeleteOutlineOutlinedIcon fontSize='medium' className='text-blue-500' /></IconButton>
                            </div>

                        </Grid>
                    ))}
                </Box> */}
                        <Box className="rounded-lg">
                            <TableContainer className="rounded-lg" sx={{ overflow: "visible", position: "relative" }}>
                                <Table>
                                    <TableHead
                                        sx={{
                                            backgroundColor: mode === "light" ? "#f7f9fc" : "#171717",
                                        }}
                                        className='rounded-md'
                                    >
                                        <TableRow>
                                            <TableCell sx={{ flex: 1, textAlign: 'center' }}>
                                                S/N
                                            </TableCell>
                                            <TableCell sx={{ flex: 1, textAlign: 'center' }}>
                                                Leave Type
                                            </TableCell>
                                            <TableCell sx={{ flex: 1, textAlign: 'center' }}>
                                                Number of Leaves
                                            </TableCell>
                                            <TableCell sx={{ flex: 1, textAlign: 'center' }}>
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredRows?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ flex: 1, textAlign: 'center' }}>{index + 1}</TableCell>
                                                <TableCell sx={{ flex: 1, textAlign: 'center' }}>{item.name}</TableCell>
                                                <TableCell sx={{ flex: 1, textAlign: 'center' }}>
                                                    {item.noOfLeaves}
                                                </TableCell>
                                                <TableCell sx={{
                                                    flex: 1, textAlign: 'center', alignItems: "center", justifyContent: "center", margin: "auto", position: "relative", overflow: "visible",
                                                }}>
                                                    <div className='cursor-pointer' onClick={() => toggleMenu(item._id)} >
                                                        <GoKebabHorizontal size={20} className='m-auto' />
                                                    </div>
                                                    {openMenuId == item._id && (
                                                        <Box sx={{ bgcolor: "background.view", zIndex: 1000, }} className="absolute right-0 mt-2 w-32 shadow-lg rounded-lg py-2">
                                                            <ul className="text-sm">
                                                                <li className="cursor-pointer "
                                                                    onClick={() => {
                                                                        setSelectLeaveType(item);
                                                                        handleOpen();
                                                                    }}
                                                                >
                                                                    <div className="flex items-center gap-2">
                                                                        <IconButton sx={{ backgroundColor: "transparent" }}>
                                                                            <VscEye style={{ fontSize: "18px" }} />
                                                                        </IconButton>
                                                                        <button className="block w-full text-left py-2 ">
                                                                            Edit
                                                                        </button>
                                                                    </div>
                                                                </li>

                                                                {/* <IconButton
                                                    onClick={() => {
                                                        setSelectLeaveType(item);
                                                        handleOpen();
                                                    }}
                                                >
                                                    <img
                                                        src={view}
                                                        alt="view"
                                                        className="w-[18px] h-[18px]"
                                                    />
                                                </IconButton> */}
                                                                <li className="cursor-pointer">
                                                                    <div
                                                                        className="flex items-center gap-2"
                                                                        onClick={() => {
                                                                            setSelectLeaveType(item);
                                                                            openDelete();
                                                                        }}
                                                                    >
                                                                        <IconButton sx={{ backgroundColor: "transparent" }}>
                                                                            <DeleteOutlineOutlinedIcon style={{ fontSize: "16px" }} />
                                                                        </IconButton>
                                                                        <button className="block w-full text-left py-2">
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            {/* <IconButton
                                                    onClick={() => {
                                                        setSelectLeaveType(item);
                                                        openDelete();
                                                    }}
                                                >
                                                    <DeleteOutlineOutlinedIcon
                                                        fontSize="medium"
                                                        className="text-blue-500"
                                                    />
                                                </IconButton> */}
                                                        </Box>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </>
            ) : (
                <div className="w-full md:h-[80vh] h-[65vh] flex justify-center items-center">
                    <div className="flex justify-center gap-3 flex-col items-center p-2 w-full h-full">
                        <img src="/images/leaveSetting.png" className="h-[130px] md:h-[200px]" alt="" />
                        <p className="text-[16px] md:text-[22px]">No settings available!</p>
                        <p className="text-[14px] md:text-[16px] text-[#868686] text-center w-[90%] md:w-[40%]">
                            Customize the number and type of leaves your employees are entitled to,
                            to ensure effectiveness in the organization.
                        </p>

                        {currentOrg.type == "Owner" &&
                            <button
                                className="text-white text-[14px] md:text-base py-2 md:py-2 px-2 md:px-3 rounded-lg bg-[#0080FF]"
                                onClick={() => {
                                    setSelectLeaveType({});
                                    handleOpen();
                                }}
                            >
                                <span>Add Leave Type</span>
                            </button>
                        }
                    </div>
                </div>
            )}
            <Modal
                open={deleteState}
                onClose={closeDelete}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box
                    sx={{ backgroundColor: "background.paper" }}
                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 rounded-lg shadow-lg w-[90%] md:w-[450px]"
                >
                    {/* <CardContent> */}

                    <h2 className="text-lg font-bold mb-3">Delete {selectLeaveType.name}</h2>
                    {/* <Typography variant='h5' fontWeight={500}>
                            Delete {selectLeaveType.name}
                        </Typography> */}
                    {/* <Divider sx={{ my: 1.5 }} /> */}
                    {/* <Typography variant='subtitle01'> */}
                    <p className="text-sm mb-2 text-[#A5A5A5]">
                        Do you really want to delete the {selectLeaveType.name} ?
                    </p>
                    <p className="text-red-500 text-sm mt-10 my-5">
                        This action cannot be undone.
                    </p>
                    {/* </Typography> */}
                    {/* </CardContent> */}

                    <div className="flex justify-end gap-3">
                        <Button variant="outlined" color='white' sx={{ paddingX: { md: 3, xs: 1 } }} onClick={closeDelete}>
                            Close
                        </Button>
                        <Button variant="contained" color="primary" sx={{ backgroundColor: "#0080ff", paddingX: { md: 3, xs: 1 } }} onClick={() => deleteLeaveTypes(selectLeaveType._id ?? selectLeaveType)}>
                            Delete
                        </Button>
                    </div>
                    {/* <CardActions sx={{ mt: 3, justifyContent: 'flex-end', p: 2 }}>
                        <Button variant='outlined' onClick={closeDelete}>
                            Cancel
                        </Button>
                        <Button
                            variant='contained'
                            color='warning'
                            onClick={() => deleteLeaveTypes(selectLeaveType._id)}
                        >
                            Delete
                        </Button>
                    </CardActions> */}
                </Box>
            </Modal>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'>
                <LeaveModel
                    handleClose={handleClose}
                    leavesTypes={leavesTypes}
                    leaveTypeId={selectLeaveType._id}
                    fetchLeaveType={fetchLeaveType}
                    openDelete={openDelete}
                    setSelectLeaveType={setSelectLeaveType}
                    selectLeaveType={selectLeaveType}
                />
            </Modal>
        </Box>
    );
};

export default LeaveSettingPage;
